module.exports = __webpack_public_path__ + "static/media/app-store.72846d0b.svg";